import React, { useEffect, useState } from "react";
import {
  generateDateArrayDinein,
  generateTimeArrayDinein,
  getFutureTimes,
} from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { createDineInReservation } from "../../store/chefActions";
import { toast } from "react-toastify";
import { bottomBarActions } from "../../store/bottomBarSlice";

const DineInComponent = ({ currentChefInfo }) => {
  const chefId = currentChefInfo._id;
  const dispatch = useDispatch();
  const userid = useSelector(({ auth }) => auth.user.userid);
  const createReservationBookingLoading = useSelector((state) => state.chef.createReservationBookingLoading);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedPeople, setSelectedPeople] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  useEffect(() =>{
    if(!createReservationBookingLoading){
      setSelectedDate(null);
      setSelectedPeople(null);
      setSelectedTime(null);
    }

  },[createReservationBookingLoading])

  const dateArray = generateDateArrayDinein();
  const timeArray = generateTimeArrayDinein();
  const todayTimeArray = getFutureTimes();

  const handleSelection = (type, value) => {
    switch (type) {
      case "date":
        setSelectedDate(value === selectedDate ? null : value);
        setSelectedTime(null);
        break;
      case "people":
        setSelectedPeople(value === selectedPeople ? null : value);
        break;
      case "time":
        setSelectedTime(value === selectedTime ? null : value);
        break;
      default:
        break;
    }
  };

  const createDineInBookingApi = () => {
    const formattedDate = new Date(selectedDate).toISOString().split('T')[0];
    const payload = {
      userId: userid,
      chefId: chefId,
      day: formattedDate,
      numberOfPeople: selectedPeople,
      time: selectedTime,
    };
    if(!userid){
      dispatch(bottomBarActions.loadTab({ tabName: "account" }));
      return
    }
    dispatch(createDineInReservation(payload));
  };

  const isToday = (dateString) => {
    const inputDate = new Date(dateString);
    const today = new Date();

    return (
      inputDate.getUTCFullYear() === today.getUTCFullYear() &&
      inputDate.getUTCMonth() === today.getUTCMonth() &&
      inputDate.getUTCDate() === today.getUTCDate()
    );
  };

  const getButtonStyle = (currentValue, selectedValue) => {
    return currentValue === selectedValue
      ? { backgroundColor: "rgb(248, 237, 213)" }
      : {};
  };

  const timeValueArray = isToday(selectedDate) ? todayTimeArray : timeArray;
  const isValueFilled = !!selectedDate && !!selectedPeople && !!selectedTime

  return (
    <div className="dineInWrapper">
      <div className="dineInLabelContent Satoshi">Book a Table</div>

      <div className="dineInLabelDayWrapper">
        <div className="dineInLabelDayLabel Satoshi">What Day?</div>
        <div className="daySelectionContainer">
          {dateArray.map((date) => (
            <button
              key={date.value}
              className="daySelectionBtn"
              onClick={() => handleSelection("date", date.value)}
              style={getButtonStyle(date.value, selectedDate)}
            >
              <div className="daySelectionBtnDayName Satoshi">
                {date.dayName}
              </div>
              <div className="daySelectionBtnDayLabel Satoshi">
                {date.label}
              </div>
            </button>
          ))}
        </div>
      </div>
      <div className="dineInLabelDayWrapper">
        <div className="dineInLabelDayLabel Satoshi">How Many People?</div>
        <div className="daySelectionContainer">
          {[1, 2, 3, 4, 5, 6].map((count) => (
            <button
              key={count}
              className="countSelectionBtn"
              onClick={() => handleSelection("people", count)}
              style={getButtonStyle(count, selectedPeople)}
            >
              <div className="daySelectionBtnDayLabel Satoshi">{count}</div>
            </button>
          ))}
        </div>
      </div>
      <div className="dineInLabelDayWrapper">
        <div className="dineInLabelDayLabel Satoshi">What Time?</div>
        <div className="daySelectionContainer">
          {timeValueArray.map((time) => (
            <button
              key={time.value}
              className="timeSelectionBtn"
              onClick={() => handleSelection("time", time.value)}
              style={getButtonStyle(time.value, selectedTime)}
            >
              <div className="daySelectionBtnDayLabel Satoshi">{time.time}</div>
            </button>
          ))}
        </div>
      </div>
      <button
        className="payBottomModalContainerConfirmBtn Satoshi"
        style={{ marginTop: 30 }}
        onClick={createDineInBookingApi}
        disabled={!isValueFilled || createReservationBookingLoading}
      >
        <div className="payBottomModalContainerConfirmBtnContent">Book</div>
      </button>
      
    </div>
  );
};

export default DineInComponent;
